// extracted by mini-css-extract-plugin
var _1 = "SelectedFileStyle-module__selected-file___z5VXp";
var _2 = "SelectedFileStyle-module__selected-file-icon___AXZ91";
var _3 = "SelectedFileStyle-module__selected-file-name-section___RZGmm";
var _4 = "SelectedFileStyle-module__selected-file-name-section-grayscale___neAXD";
var _5 = "SelectedFileStyle-module__selected-file___z5VXp";
var _6 = "SelectedFileStyle-module__selected-file-icon___AXZ91";
var _7 = "SelectedFileStyle-module__selected-file-name-section___RZGmm";
var _8 = "SelectedFileStyle-module__selected-file-name-section-grayscale___neAXD";
export { _1 as "selected-file", _2 as "selected-file-icon", _3 as "selected-file-name-section", _4 as "selected-file-name-section-grayscale", _5 as "selectedFile", _6 as "selectedFileIcon", _7 as "selectedFileNameSection", _8 as "selectedFileNameSectionGrayscale" }
